
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 23.97 23.964"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Pfad 478","d":"M.501 23.964a.505.505 0 01-.354-.146.5.5 0 01-.121-.511l2.121-6.364a.4.4 0 01.021-.047.469.469 0 01.087-.133l.009-.01L18.027.989A3.483 3.483 0 0120.46 0h.065a3.5 3.5 0 012.457 5.931l-.7.7-.015.016L7.219 21.696a.3.3 0 01-.033.028.529.529 0 01-.112.071h-.005a.24.24 0 01-.054.023l-6.356 2.12a.489.489 0 01-.158.026zm.793-1.291l4.646-1.549-3.1-3.1zm5.574-2.037L21.209 6.293l-3.536-3.536L3.33 17.1zM21.915 5.585l.354-.354a2.5 2.5 0 00-1.761-4.23h-.045a2.488 2.488 0 00-1.736.7l-.347.347z","fill":"#004588"}})])
          )
        }
      }
    